import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterLength',
    pure:false
})
export class FilterLengthPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    //console.log(value.length)
    return value.length;
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/pipes/filter-length.pipe.ts